







import n from '@/utils/notifications'
import q from '@/graphql/query'

export default {
    name: 'params_string'

    props:
        component:
            required: true
        date:
            required: true
        update:
            default: false

    watch:
        update: (new_one, old_one)->
            if new_one != old_one
                @get_variable_payroll_params()

    data: ()->
        params: {}

    computed:
        dates: ()->
            resp = @date_process()
            return [resp[0].toLocaleDateString('fr-FR', {day:'numeric', month:'long', year:'numeric'}), resp[1].toLocaleDateString('fr-FR', {day:'numeric', month:'long', year:'numeric'})]

    methods:
        date_process: ()->
            sending_date = ""
            max_day_date = ""
            date = new Date(@date)
            if @params.sending_day < 15
                sending_date = new Date(date.setMonth(date.getMonth()+1))
            else
                sending_date = new Date(date.setMonth(date.getMonth()))
            sending_date = new Date(sending_date.setDate(@params.sending_day))
            tmp_date = new Date(sending_date)
            sending_date = new Date(sending_date.setDate(@params.sending_day))
            max_day_date = new Date(tmp_date.setDate(tmp_date.getDate()-@params.max_date_delta))
            @$emit('new-dates', [sending_date, max_day_date])
            return [sending_date, max_day_date]

        get_variable_payroll_params: ()->
            self = @
            q.run('get_variable_payroll_params', [@$store.getters.current_company.uid, @date])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("params_string: get_variable_payroll_params: then", e.message)
                else
                    # console.log "GET VARIABLE PAYROLL PARAMS : ", resp.body.data.variable_payroll_params
                    if resp.body.data.variable_payroll_params != null
                        self.params = resp.body.data.variable_payroll_params
                        self.$emit('params', self.params)
                    else
                        self.params = {
                            uid: ''
                            max_date_delta: 3
                            sending_day: 1
                        }
                    self.date_process()
            .catch (resp)->
                n.catch_error(resp, "params_string: get_variable_payroll_params()")
            
    beforeMount: ()->
        @get_variable_payroll_params()
}
